import { useReducer, useState, useEffect } from "react";
import UserService from "../../services/UserService";

let initialState = {
    name: "",
    email: "",
    type: "",
    isActive: false,
};

let initialPasswordState = {
    password: "",
    password2: "",
};

const Actions = {
    INITIAL: "INITIAL",
    NAME: "NAME",
    EMAIL: "EMAIL",
    TYPE: "TYPE",
    IS_ACTIVE: "IS_ACTIVE",
};

const reducer = (state, payload) => {
    switch (payload.action) {
        case Actions.INITIAL:
            initialState = {
                name: payload.value.name,
                email: payload.value.email,
                type: payload.value.role.name,
                isActive: payload.value.isActive,
            }
            return initialState
        case Actions.NAME:
            return {
                ...state,
                name: payload.value,
            }
        case Actions.EMAIL:
            return {
                ...state,
                email: payload.value,
            }
        case Actions.TYPE:
            return {
                ...state,
                type: payload.value,
            }
        case Actions.IS_ACTIVE:
            return {
                ...state,
                isActive: payload.value,
            }
        default:
            return state
    }
}

const options = ['Administrador', 'Operador'];

const useUserDetail = (userId) => {

    const [updateSuccess, setUpdateSuccess] = useState(false);
    const [updateFailure, setUpdateFailure] = useState(false);
    const [passwordState, setPasswordState] = useState(initialPasswordState);
    const [passwordNotMatch, setPasswordNotMatch] = useState(false);

    const setFirstPassword = (value) => {
        setPasswordNotMatch(false);
        setPasswordState({
            ...passwordState,
            password: value,
        })
    };

    const setSecondPassword = (value) => {
        setPasswordNotMatch(false);
        setPasswordState({
            ...passwordState,
            password2: value,
        })
    };

    const updatePassword = async () => {
        if (passwordState.password === passwordState.password2) {
            const response = await UserService.updateUser(userId, {
                ...userDetails,
                password: passwordState.password,   
            });
            if (response) {
                setUpdateSuccess(true);
                setPasswordState(initialPasswordState);
            } else {
                setUpdateFailure(true);
            }
        } else {
            setPasswordNotMatch(true);
        }
    };

    const getUser = async () => {
        const response = await UserService.getUser(userId);
        if (response) {
            setInitial(response);
        }
    };

    const updateUser = async () => {
        const response = await UserService.updateUser(userId, userDetails);
        if (response) {
            setInitial(response);
            setUpdateSuccess(true);
        } else {
            setUpdateFailure(true)
        }
    };

    const [userDetails, dispatch] = useReducer(reducer, initialState);
    const [originalDataChanged, setOriginalDataChanged] = useState(false);

    useEffect(() => {
        originalDataHasChanged();
    }, [userDetails]);

    const originalDataHasChanged = () => {

        const hasChanged = userDetails.name !== initialState.name
            || userDetails.email !== initialState.email
            || userDetails.type !== initialState.type
            || userDetails.isActive != initialState.isActive

        setOriginalDataChanged(hasChanged);
    };

    const setInitial = (data) => {
        dispatch({ action: Actions.INITIAL, value: data });
    };

    const updateName = (name) => {
        dispatch({ action: Actions.NAME, value: name });
    };

    const updateEmail = (email) => {
        dispatch({ action: Actions.EMAIL, value: email });
    };

    const updateType = (type) => {
        dispatch({ action: Actions.TYPE, value: type });
    };

    const updateUserStatus = (isActive) => {
        dispatch({ action: Actions.IS_ACTIVE, value: isActive });
    };

    const handleClick = () => {
        setUpdateSuccess(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUpdateSuccess(false);
    };

    return {
        userDetails,
        updateName,
        updateEmail,
        updateType,
        updateUserStatus,
        options,
        getUser,
        originalDataChanged,
        updateUser,
        updateSuccess,
        updateFailure,
        handleClick,
        handleClose,
        // region password change
        passwordState,
        setFirstPassword,
        setSecondPassword,
        updatePassword,
        // region change password validation
        passwordNotMatch,
    }
}

export { useUserDetail };